import styled from "styled-components";

import designSystemColors from "../../styles";

export const ModalTitle = styled.span`
  font-weight: bold;
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  align-items: center;
  justify-content: center;
`;

export const ModalDescription = styled.span`
  font-weight: bold;
  text-align: center;
`;

export const ModalButton = styled.button.attrs(() => ({
  type: "button",
}))<React.ButtonHTMLAttributes<HTMLButtonElement>>`
  border-radius: 4px;
  border: none;
  padding: 6px 12px;
  background: ${designSystemColors.secondaryButtons};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${designSystemColors.textGeneralButtons};
  text-align: center;
  font-family: Roboto;
  font-weight: bold;
  font-size: 16px;

  transition: ease 0.5s linear;
`;
